import { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import {
  Brain, CheckCircle2, AlertCircle, XCircle, Sparkles,
  ShieldAlert, TrendingDown, Loader2,
} from "lucide-react";

const typeStyles = {
  success:    "bg-emerald-50 border-emerald-200 text-emerald-700",
  warning:    "bg-amber-50 border-amber-200 text-amber-700",
  error:      "bg-red-50 border-red-200 text-red-700",
  info:       "bg-blue-50 border-blue-200 text-blue-700",
  suggestion: "bg-purple-50 border-purple-200 text-purple-700",
};

function buildInsights(efficiency, bottlenecks) {
  const insights = [];
  if (efficiency?.breakdown) {
    const { prep_time, cancel_rate, volume, on_time } = efficiency.breakdown;
    if (prep_time?.score >= 80)       insights.push({ type: "success",    text: "Tempo médio de preparo: excelente",                   icon: CheckCircle2 });
    else if (prep_time?.score < 50)   insights.push({ type: "warning",    text: "Tempo de preparo acima do ideal - revisar processos",  icon: AlertCircle  });
    if (cancel_rate?.score >= 90)     insights.push({ type: "success",    text: "Taxa de cancelamento: perfeita",                       icon: CheckCircle2 });
    else if (cancel_rate?.score < 60) insights.push({ type: "error",      text: "Alto índice de cancelamentos - investigar causas",     icon: XCircle      });
    if (volume?.score < 40) {
      insights.push({ type: "info",       text: "Volume baixo de pedidos",                                   icon: TrendingDown });
      insights.push({ type: "suggestion", text: "Sugestão: ativar promoções ou campanhas de marketing",      icon: Sparkles     });
    }
    if (on_time?.score >= 80)         insights.push({ type: "success",    text: "Entregas no prazo: excelente desempenho",              icon: CheckCircle2 });
  }
  if (bottlenecks?.status === "critical") insights.push({ type: "error", text: "Gargalo crítico detectado na operação", icon: ShieldAlert });
  if (insights.length === 0)              insights.push({ type: "info",  text: "Dados insuficientes para análise completa",             icon: Brain        });
  return insights;
}

export function AIAnalysis({ efficiency, bottlenecks, kitchen, onAnalyze, analyzing }) {
  const [insights, setInsights] = useState([]);

  useEffect(() => {
    setInsights(buildInsights(efficiency, bottlenecks));
  }, [efficiency, bottlenecks, kitchen]);

  return (
    <Card className="bg-gradient-to-br from-indigo-50 to-purple-50 border-indigo-200" data-testid="ai-analysis-card">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-indigo-700">
          <Brain className="w-5 h-5" />
          Inteligência Operacional
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-sm text-indigo-600 font-medium">IA detectou:</p>
        <div className="space-y-2">
          {insights.map((insight, i) => {
            const Icon = insight.icon;
            return (
              <div key={i} className={`flex items-center gap-2 p-3 rounded-lg border ${typeStyles[insight.type]}`}>
                <Icon className="w-4 h-4 flex-shrink-0" />
                <span className="text-sm font-medium">{insight.text}</span>
              </div>
            );
          })}
        </div>
        <Button
          onClick={onAnalyze}
          disabled={analyzing}
          className="w-full mt-4 bg-indigo-600 hover:bg-indigo-700"
          data-testid="analyze-performance-btn"
        >
          {analyzing ? (
            <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Analisando...</>
          ) : (
            <><Sparkles className="w-4 h-4 mr-2" /> Analisar Desempenho</>
          )}
        </Button>
      </CardContent>
    </Card>
  );
}
